import { Component } from '@angular/core';
import { SiDialogComponent } from '../si-modal';

@Component({
    templateUrl: './hubspot-crm-prompt.component.html',
    styleUrls: ['./hubspot-crm-prompt.component.scss'],
    standalone: false
})
export class HubspotCrmPromptComponent {
    selectedOption: 'hubspotContacts' | 'hubspotCrm';
    private returnData: { success: boolean, hsCrmValue?: boolean };

    proceed(modal: SiDialogComponent) {
        this.returnData = {
            success: true
        };
        switch (this.selectedOption) {
            case "hubspotContacts":
                this.returnData.hsCrmValue = false;
                break;
            case "hubspotCrm":
                this.returnData.hsCrmValue = true;
                break;
        }
        modal.onClose(this.returnData);
    }
}
